// /* eslint-disable react/no-unstable-nested-components */
// /* eslint-disable react/no-multi-comp */
// /* eslint-disable react/jsx-no-undef */
// /* eslint-disable react-hooks/exhaustive-deps */
// import React, { useEffect, useState } from 'react';
// import { FSBTable } from 'components/common/FSBTable';
// import { staffAssociatedVendorColumns } from 'pages/Staff/constant';
// import { useQuery } from '@apollo/client';
// import { STAFF_LIST } from 'utils/CommonGraphQL';
// import Loader from 'components/common/Loader';
// import DateFormatter from 'components/DateFormatter';

// const StaffAllocateVendorList = ({
//   staffId,
//   searchString,
//   rowSelection,
//   onSelectedRowsChange,
//   roleList = [],
//   setVendorList,
// }) => {
//   // const [rowSelection, setRowSelection] = useState({});
//   // const [updateRecordModal, setUpdateRecordModal] = useState(false);
//   // const [addRecordModal, setAddRecordModal] = useState(false);
//   const name = roleList.length > 0 ? 'bdeAssignedTraders' : 'assignedTraders';
//   const assignDate = roleList.length > 0 ? 'bdeAssignedAt' : 'rmAssignedAt';

//   const searchFilter =
//     roleList.length > 0
//       ? 'bdeAssignedTraderSearchFilter'
//       : 'assignedTraderSearchFilter';

//   const [filters, setFilters] = useState({
//     filter: [
//       {
//         key: 'id',
//         value: staffId,
//         type: 'INT',
//         addValue: searchString,
//         addKey: searchFilter,
//         op: 'EQ',
//       },
//     ],
//   });

//   useEffect(() => {
//     setFilters({
//       ...filters,
//       filter: [
//         {
//           key: 'id',
//           value: staffId,
//           type: 'INT',
//           addValue: searchString,
//           addKey: searchFilter,
//           op: 'EQ',
//         },
//       ],
//     });
//   }, [searchString]);

//   const { data, loading, error } = useQuery(STAFF_LIST, {
//     variables: {
//       filter: [
//         { key: 'id', value: staffId, type: 'INT', op: 'EQ' },
//         ...filters.filter,
//       ],
//     },
//     fetchPolicy: 'network-only',
//   });

//   useEffect(() => {
//     if (data?.usersFilter?.users[0]?.[name])
//       setVendorList(
//         data?.usersFilter?.users[0]?.[name]?.map((item) => item?.id) || [],
//       );
//   }, [data]);

//   if (loading) return <Loader />;
//   if (error) return `There is an error on this page : ${error.message} `;
//   if (!data?.usersFilter?.users) return 'Staff not available';

//   const staffDetail = data.usersFilter.users[0];

//   // const onSelectedRowsChange = async (rows) => {
//   //   await setRowSelection(rows);
//   // };

//   // const handleRMToggle = () => {
//   //   setUpdateRecordModal(!updateRecordModal);
//   // };
//   // const onCloseUpdatePopup = () => {
//   //   setUpdateRecordModal(!updateRecordModal);
//   // };

//   // const onCloseAddPopup = () => {
//   //   setAddRecordModal(!addRecordModal);
//   // };

//   const BDEAndRMFormatter = (cell) => {
//     return (
//       <div>
//         <DateFormatter dateTime={cell?.row?.original?.[assignDate]} />
//       </div>
//     );
//   };
//   const findIndexOfItem = (item) => {
//     return staffAssociatedVendorColumns.findIndex(
//       (itm) => itm.accessorKey === item,
//     );
//   };
//   staffAssociatedVendorColumns[findIndexOfItem('rmAssignedAt')].cell =
//     BDEAndRMFormatter;

//   return (
//     <div>
//       {/* <div className="text-start">
//         <Button
//           size="sm"
//           color="primary"
//           className="me-3"
//           onClick={() => setAddRecordModal(!addRecordModal)}
//         >
//           Add Vendors
//         </Button>
//         <Button
//           size="sm"
//           color="primary"
//           onClick={handleRMToggle}
//           disabled={Object.keys(rowSelection).length === 0}
//         >
//           Assign another RM
//         </Button>
//       </div>
//       <FSBModal
//         title="Allocate RM"
//         closeButtonLabel=""
//         confirmButtonLabel=""
//         message=""
//         open={updateRecordModal}
//         onClose={onCloseUpdatePopup}
//         toggleAlert={onCloseUpdatePopup}
//         modalClass="right-drawer right-drawer-details assign-vendor"
//       >
//         <AssignAnotherRM
//           id={staffId}
//           onCloseUpdatePopup={onCloseUpdatePopup}
//           rowSelection={Object.keys(rowSelection)}
//           drawerToggle={drawerToggle}
//         />
//       </FSBModal>

//       <FSBModal
//         title="Assign Vendors to RM"
//         closeButtonLabel=""
//         confirmButtonLabel=""
//         message=""
//         open={addRecordModal}
//         onClose={onCloseAddPopup}
//         toggleAlert={onCloseAddPopup}
//         modalClass="right-drawer right-drawer-details assign-vendor"
//       >
//         <AddAllocateVendor
//           id={staffId}
//           onCloseAddPopup={onCloseAddPopup}
//           drawerToggle={drawerToggle}
//         />
//       </FSBModal> */}
//       <FSBTable
//         getRowId={(row) => row.id}
//         data={staffDetail?.[name] || []}
//         totalCount={staffDetail?.[name].length}
//         totalPages={0}
//         columns={staffAssociatedVendorColumns}
//         pageSize={staffDetail?.[name].length}
//         keyField="id"
//         showSearch={false}
//         showFilters
//         showDelete={false}
//         showPagination={false}
//         remote
//         striped={false}
//         hover={false}
//         bordered={false}
//         wrapperClass="table-responsive word-break"
//         searchPlaceholder="Search Vendors"
//         onSelectedRowsChange={onSelectedRowsChange}
//         rowSelection={rowSelection}
//       />
//     </div>
//   );
// };

// export default StaffAllocateVendorList;

/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/no-multi-comp */
/* eslint-disable react/jsx-no-undef */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useMemo } from 'react';
import { FSBTable } from 'components/common/FSBTable';
import { staffAssociatedVendorColumns } from 'pages/Staff/constant';
import { useQuery } from '@apollo/client';
import { STAFF_LIST } from 'utils/CommonGraphQL';
import Loader from 'components/common/Loader';
import DateFormatter from 'components/DateFormatter';

const StaffAllocateVendorList = ({
  staffId,
  searchString,
  rowSelection,
  onSelectedRowsChange,
  roleList = [],
  setVendorList,
}) => {
  const name = roleList.length > 0 ? 'bdeAssignedTraders' : 'assignedTraders';
  const assignDate = roleList.length > 0 ? 'bdeAssignedAt' : 'rmAssignedAt';
  const searchFilter =
    roleList.length > 0
      ? 'bdeAssignedTraderSearchFilter'
      : 'assignedTraderSearchFilter';

  const [filters, setFilters] = useState({
    filter: [
      {
        key: 'id',
        value: staffId,
        type: 'INT',
        addValue: searchString,
        addKey: searchFilter,
        op: 'EQ',
      },
    ],
  });

  useEffect(() => {
    setFilters({
      ...filters,
      filter: [
        {
          key: 'id',
          value: staffId,
          type: 'INT',
          addValue: searchString,
          addKey: searchFilter,
          op: 'EQ',
        },
      ],
    });
  }, [searchString]);

  const { data, loading, error } = useQuery(STAFF_LIST, {
    variables: {
      filter: [
        { key: 'id', value: staffId, type: 'INT', op: 'EQ' },
        ...filters.filter,
      ],
    },
    fetchPolicy: 'network-only',
  });

  useEffect(() => {
    const firstUser = data?.usersFilter?.users?.[0];
    if (firstUser?.[name]) {
      setVendorList(firstUser?.[name]?.map((item) => item?.id) || []);
    }
  }, [data, name, setVendorList]);

  // useMemo का use करके हर बार नई columns बनाएं
  const tableColumns = useMemo(() => {
    const BDEAndRMFormatter = (cell) => {
      return (
        <div>
          <DateFormatter dateTime={cell?.row?.original?.[assignDate]} />
        </div>
      );
    };

    // Original columns की deep copy बनाएं
    const newColumns = staffAssociatedVendorColumns.map((col) => ({ ...col }));

    // सही column find करें और update करें
    const columnToUpdate =
      roleList.length > 0 ? 'bdeAssignedAt' : 'rmAssignedAt';
    const columnIndex = newColumns.findIndex(
      (col) => col.accessorKey === columnToUpdate,
    );

    if (columnIndex !== -1) {
      newColumns[columnIndex] = {
        ...newColumns[columnIndex],
        cell: BDEAndRMFormatter,
      };
    }

    return newColumns;
  }, [roleList, assignDate]);

  if (loading) return <Loader />;
  if (error) return `There is an error on this page : ${error.message} `;
  if (!data?.usersFilter?.users?.length) return 'Staff not available';

  const staffDetail = data.usersFilter.users[0];

  return (
    <div>
      <FSBTable
        getRowId={(row) => row.id}
        data={staffDetail?.[name] || []}
        totalCount={staffDetail?.[name]?.length || 0}
        totalPages={0}
        columns={tableColumns}
        pageSize={staffDetail?.[name]?.length || 0}
        keyField="id"
        showSearch={false}
        showFilters
        showDelete={false}
        showPagination={false}
        remote
        striped={false}
        hover={false}
        bordered={false}
        wrapperClass="table-responsive word-break"
        searchPlaceholder="Search Vendors"
        onSelectedRowsChange={onSelectedRowsChange}
        rowSelection={rowSelection}
      />
    </div>
  );
};

export default StaffAllocateVendorList;
